<p-dialog showHeader="false" [(visible)]="display" [modal]="true" [header]="title" #dialog>

    <div class="animated fadeIn">
        <div class="row pb-1">
            <div class="col-1">
                <div class="box-leyenda dia-actual">D</div>
            </div>
            <div class="col-3">Día actual</div>
            <div class="col-1">
                <div class="box-leyenda dia-seleccionado">D</div>
            </div>
            <div class="col-3">Día seleccionado</div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <form [formGroup]="form" autocomplete="off">
                    <p-calendar formControlName="rangeDates" selectionMode="range" inputStyleClass="form-control" [inline]="true" [showButtonBar]="true"
                                [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                </form>
            </div>
        </div>
    </div>

    <p-footer>
        <button type="button" [disabled]="formIsUntouched" class="btn btn-secondary btn-sm" (click)="acceptDialog($event)"><i class="fa fa-check"></i> Aceptar</button>
        <button type="button" class="btn btn-secondary btn-sm" (click)="cancelDialog($event)"><i class="fa fa-times"></i> Cancelar</button>
    </p-footer>

</p-dialog>